// @ts-strict-ignore
/**
 * @owner @Appboy/operator
 */

import partition from "lodash/partition";
/*
 * Pusher pub/sub to get data from pusher downstream
 * to React without having to add more network listeners
 */
export default class PusherObserver {
  static MAX_UNHANDLED_MESSAGES = 100;

  static subscriptions = {};
  static unhandledMessages = [];

  static on(key: string, fn: (data: any) => void) {
    this.subscriptions[key] = fn;
  }

  static off(key: string) {
    delete this.subscriptions[key];
  }

  static emit(fnKey: string, data?: any) {
    if (this.subscriptions[fnKey]) {
      this.subscriptions[fnKey](data);
    } else {
      this.unhandledMessages.push({ fnKey, data });
      if (this.unhandledMessages.length > this.MAX_UNHANDLED_MESSAGES) {
        this.unhandledMessages.shift();
      }
    }
  }

  /* Emits the LAST RECEIVED, unhandled message for the given key. Additionally
   * it prunes any older messages with the same key from `unhandledMessages`.
   */
  static handleMissedMessage(fnKey: string) {
    if (this.subscriptions[fnKey]) {
      const [inbox, unhandledMessages] = partition(this.unhandledMessages, { fnKey: fnKey });
      this.unhandledMessages = unhandledMessages;
      if (inbox.length > 0) {
        this.emit(fnKey, inbox[inbox.length - 1].data);
      }
    }
  }
}
